import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Equipment from './pages/Equipment';
import PartnerStock from './pages/PartnerStock';
import Bookings from './pages/Bookings';
import Users from './pages/Users';
import Profile from './pages/Profile';
import About from './pages/About';
import Logs from './pages/Logs';
import NotificationSettings from './pages/NotificationSettings';
import Layout from './components/Layout';
import { auth } from './api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ssoError, setSsoError] = useState('');

  useEffect(() => {
    // Пришли с плитки «Склад» в Axion: в адресе одноразовый талон. Убираем его из
    // адресной строки сразу (не оставлять в истории и не отдать повторно) и меняем на
    // токен склада — он заменяет прежний вход, если в этом браузере был кто-то другой.
    const params = new URLSearchParams(window.location.search);
    const ticket = params.get('sso');
    if (ticket) {
      window.history.replaceState(null, '', window.location.pathname);
      auth.loginFromAxion(ticket)
        .then((data) => {
          localStorage.setItem('token', data.access_token);
          return auth.getCurrentUser();
        })
        .then(setUser)
        .catch((err) => {
          localStorage.removeItem('token');
          setSsoError(err.response?.data?.detail || 'Не удалось войти из Axion. Войдите по паролю.');
        })
        .finally(() => setLoading(false));
      return;
    }

    const token = localStorage.getItem('token');
    if (token) {
      auth.getCurrentUser()
        .then(setUser)
        .catch(() => {
          localStorage.removeItem('token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-xl text-gray-600">Загрузка...</div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!user ? <Login setUser={setUser} notice={ssoError} /> : <Navigate to="/" />} />
        <Route path="/register" element={!user ? <Register setUser={setUser} /> : <Navigate to="/" />} />
        
        <Route path="/" element={user ? <Layout user={user} setUser={setUser} /> : <Navigate to="/login" />}>
          <Route index element={<Dashboard />} />
          <Route path="equipment" element={<Equipment />} />
          <Route path="partners" element={<PartnerStock />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="users" element={<Users />} />
          <Route path="profile" element={<Profile user={user} setUser={setUser} />} />
          <Route path="about" element={<About />} />
          <Route path="logs" element={<Logs />} />
          <Route path="notifications" element={<NotificationSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;





